import React from 'react';
import {AppliesToFriendlyNames, currencyFormatNoDecimals, SOURCES} from "../../shared/shared";
import "./pdf-plan.css";
import PdfHeader from './pdfHeader';
import {INCOME_TYPES, NONQUAL_ACCOUNTS, PRETAX_ACCOUNTS, TAXFREE_ACCOUNTS} from "../../shared/constants";

const PdfPlanInput = (props) => {
    const titleh1Style = { margin: '10px', color: 'white' }
    const titleh2Style = { margin: '5px' }
    const containerClientStyle = { width: '45%' }
    const inputClientStyle = { borderBottom: 'none', color: "#444", width: '80%', }
    const questionStyle = { color: "#444", fontWeight: "bold" }
    const answerStyle = { borderBottom: 'none', color: "#444", width: '100%', margin: '1em 0' }
    const sectionh1Style = { display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#157ee8', height: '48px', margin: '5px 0' }
    const subSectionStyle = { color: '#157ee8', margin: '25px 0', fontSize: "1em" }
    const clientSpouseStyle = { fontWeight: '600', color: "#444", marginTop: "0.5em", marginBottom: "0.25em", display: "inline-block" }

    const financialDataItemStyle = {
        display: "inline-block",
        width: "150px",
        marginRight: "1em"
    };

    const financialDataItemTRStyle = {
        borderBottom: "1p solid #ccc"
    }

    const financialDataItemTHStyle = {
        padding: "0.5em"
    };

    const financialDataItemTDStyle = {
        padding: "0.5em",
        fontSize: "0.9em",
        textAlign: "center"
    };

    const financialDataItemLabelStyle = {
        display: "inline-block",
        marginRight: "1em"
    };

    const QuestionAndAnswer = (props) => {
        return (
            <div className='question' style={{ margin: '1em 0' }}>
                <label style={questionStyle}> {props.question}</label>
                <div style={answerStyle} >
                    {props.answer}
                </div>
            </div>
        )
    }

    const InputClientSpouse = (props) => {

        return (
            <>
                <label style={clientSpouseStyle}> {props.label}</label>
                <div style={inputClientStyle}>
                    {props.value}
                </div>
            </>)
    }

    const displayAccountTypeLabel = (dataItem) => {
        const options =
            (dataItem.taxType === "NON-QUALIFIED"
                ? NONQUAL_ACCOUNTS
                : dataItem.taxType === "PRE-TAX"
                    ? PRETAX_ACCOUNTS
                    : TAXFREE_ACCOUNTS).map(item => {
                let label = item.text;
                if (item.value === "TE_OTHER" && dataItem.accountTypeOtherName) {
                    label = dataItem.accountTypeOtherName;
                }
                return {
                    ...item,
                    text: label,
                }
            });
        const selectedOption = options.find((c) => c.value === dataItem.accountType);
        return selectedOption.text;
    };

    const displayIncomeTypeLabel = (dataItem) => {
        const options = INCOME_TYPES.map(item => {
            let label = item.text;
            if (item.value === "OTHER" && dataItem.incomeTypeOtherName) {
                label = dataItem.incomeTypeOtherName;
            }
            return {
                ...item,
                text: label,
            }
        });
        const selectedOption = options.find((c) => c.value === dataItem.incomeType);
        return selectedOption.text;
    };

    return (
        <html style={{
            fontFamily: "sans-serif"
        }}>
            <body style={{
                fontFamily: "sans-serif"
            }}>
                <PdfHeader />
                <div>
                    <div style={sectionh1Style}>
                        <h1 style={titleh1Style}> Basic Information </h1>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', margin: '0' }}>
                        <div style={containerClientStyle}>
                            <h2 style={subSectionStyle}> {"Client"}</h2>
                            <InputClientSpouse value={props.data.client.firstName} label={"First Name"} />
                            <InputClientSpouse value={props.data.client.lastName} label={"Last Name"} />
                            <InputClientSpouse value={props.data.client.age} label={"Age"} />
                            <InputClientSpouse value={props.data.client.retirementAge.value} label={"Target Retired Date"} />
                            <InputClientSpouse value={props.data.client.filingStatus.value} label={"Filling Status"} />
                        </div>

                        {props.data.client.hasSpouse ? (

                            <div style={containerClientStyle}>
                                <h2 style={subSectionStyle}> {"Spouse"}</h2>
                                <InputClientSpouse value={props.data.spouse?.firstName} label={"First Name"} />
                                <InputClientSpouse value={props.data.spouse?.lastName} label={"Last Name"} />
                                <InputClientSpouse value={props.data.spouse?.age} label={"Age"} />
                                <InputClientSpouse value={props.data.spouse?.retirementAge.value} label={"Target Retired Date"} />
                            </div>
                        ) : <div style={containerClientStyle}> </div>}
                    </div>

                    <div style={{ margin: '30px 0' }}>
                        <div style={sectionh1Style}>
                            <h1 style={titleh1Style}> Fact Finder </h1>
                        </div>
                        <div>
                            <h2 style={subSectionStyle}> Personal Information </h2>
                            {props.personalinformationQuestions.map((e) => (<QuestionAndAnswer key={e.questionId} question={e.question} answer={e.answer} />))}
                        </div>
                        <div style={{ pageBreakBefore: "always" }}>
                            <h2 style={subSectionStyle}> Saving And Contributions </h2>
                            <h3 style={subSectionStyle}> Assets  </h3>
                            {props.assetsQuestions.map((e) => (<QuestionAndAnswer key={e.questionId} question={e.question} answer={e.answer} />))}
                            <h3 style={subSectionStyle}> Life Insurance  </h3>
                            {props.lifeInsuranceQuestions.map((e) => (<QuestionAndAnswer key={e.questionId} question={e.question} answer={e.answer} />))}
                            <h3 style={subSectionStyle}> LTC/Disability Insurance Inputs </h3>
                            {props.disabilityInsuranceQuestions.map((e) => (<QuestionAndAnswer key={e.questionId} question={e.question} answer={e.answer} />))}
                        </div>
                        <div>
                            <h2 style={subSectionStyle}>Goals</h2>
                            {props.goalsQuestions.map((e) => (<QuestionAndAnswer key={e.questionId} question={e.question} answer={e.answer} />))}
                        </div>
                    </div>
                </div>

                <div className='page2' style={{ pageBreakBefore: "always" }}>
                    <div style={sectionh1Style}>
                        <h1 style={titleh1Style}> Client Financial Information </h1>
                    </div>

                    <div>
                        <h2 style={subSectionStyle}> Savings And Contributions</h2>
                        <table style={{
                            width: "100%",
                            borderCollapse: "collapse"
                        }}>
                            <thead>
                                <tr style={{
                                    backgroundColor: "#157ee8",
                                    color: "white",
                                }}>
                                    <th style={financialDataItemTHStyle}>Tax type</th>
                                    <th style={financialDataItemTHStyle}>Account Type</th>
                                    <th style={financialDataItemTHStyle}>Owner</th>
                                    <th style={financialDataItemTHStyle}>Acct Value</th>
                                    <th style={financialDataItemTHStyle}>Cost Basis</th>
                                    <th style={financialDataItemTHStyle}>Stocks</th>
                                    <th style={financialDataItemTHStyle}>Bonds</th>
                                    <th style={financialDataItemTHStyle}>Cash</th>
                                </tr>
                            </thead>
                            <tbody>
                                {props.data.accounts.length > 0 && (
                                    props.data.accounts.map((item, idx) => {
                                        return <><tr>
                                            <td style={financialDataItemTDStyle}>{item.taxType}</td>
                                            <td style={financialDataItemTDStyle}>{displayAccountTypeLabel(item)}</td>
                                            <td style={financialDataItemTDStyle}>{AppliesToFriendlyNames[item.owner] != null ? AppliesToFriendlyNames[item.owner] : item.owner}</td>
                                            <td style={financialDataItemTDStyle}>{currencyFormatNoDecimals(item.value)}</td>
                                            <td style={financialDataItemTDStyle}>{currencyFormatNoDecimals(item.costBasis)}</td>
                                            <td style={financialDataItemTDStyle}>{item.stocks}%</td>
                                            <td style={financialDataItemTDStyle}>{item.bonds}%</td>
                                            <td style={financialDataItemTDStyle}>{item.cash}%</td>
                                        </tr>
                                            <tr style={{
                                                borderBottom: "1px solid #eee"
                                            }}>
                                                <td colSpan={8} style={{
                                                    padding: "0.5em",
                                                    fontSize: "0.7em"
                                                }}>
                                                    <div style={financialDataItemStyle}>
                                                        <label style={financialDataItemLabelStyle}>Frequency</label>
                                                        <span>{item.contributions.frequency}</span>
                                                    </div>
                                                    <div style={financialDataItemStyle}>
                                                        <label style={financialDataItemLabelStyle}>Source</label>
                                                        <span>{SOURCES[item.contributions.contributionSourceType]}</span>
                                                    </div>
                                                    <div style={financialDataItemStyle}>
                                                        <label style={financialDataItemLabelStyle}>Amount</label>
                                                        <span>{currencyFormatNoDecimals(item.contributions.amount)}</span>
                                                    </div>
                                                    <div style={financialDataItemStyle}>
                                                        <label style={financialDataItemLabelStyle}>Start Year</label>
                                                        <span>{item.contributions.startYear}</span>
                                                    </div>
                                                    <div style={financialDataItemStyle}>
                                                        <label style={financialDataItemLabelStyle}>End Year</label>
                                                        <span>{item.contributions.endYear}</span>
                                                    </div>
                                                </td>
                                            </tr></>
                                    }))}
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <h2 style={subSectionStyle}>Incomes</h2>
                        <table style={{
                            width: "100%",
                            borderCollapse: "collapse"
                        }}>
                            <thead>
                                <tr style={{
                                    backgroundColor: "#157ee8",
                                    color: "white",
                                }}>
                                    <th style={financialDataItemTHStyle}>Income Type</th>
                                    <th style={financialDataItemTHStyle}>Frequency</th>
                                    <th style={financialDataItemTHStyle}>Owner</th>
                                    <th style={financialDataItemTHStyle}>Amount</th>
                                    <th style={financialDataItemTHStyle}>Tax Rate</th>
                                    <th style={financialDataItemTHStyle}>Start Year</th>
                                    <th style={financialDataItemTHStyle}>End Year</th>
                                </tr>
                            </thead>
                            <tbody>
                                {props.data.incomes.length > 0 && (
                                    props.data.incomes.map((item, idx) => {
                                        return <tr style={financialDataItemTRStyle}>
                                            <td style={financialDataItemTDStyle}>{displayIncomeTypeLabel(item)}</td>
                                            <td style={financialDataItemTDStyle}>{item.frequency}</td>
                                            <td style={financialDataItemTDStyle}>{AppliesToFriendlyNames[item.owner]}</td>
                                            <td style={financialDataItemTDStyle}>{currencyFormatNoDecimals(item.amount)}</td>
                                            <td style={financialDataItemTDStyle}>{item.taxed} %</td>
                                            <td style={financialDataItemTDStyle}>{item.startYear}</td>
                                            <td style={financialDataItemTDStyle}>{item.endYear}</td>
                                        </tr>

                                    }))}
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <h2 style={subSectionStyle}>Goals</h2>
                        <table style={{
                            width: "100%",
                            borderCollapse: "collapse"
                        }}>
                            <thead>
                                <tr style={{
                                    backgroundColor: "#157ee8",
                                    color: "white",
                                }}>
                                    <th style={financialDataItemTHStyle}>Frequency</th>
                                    <th style={financialDataItemTHStyle}>Amount</th>
                                    <th style={financialDataItemTHStyle}>Start Year</th>
                                    <th style={financialDataItemTHStyle}>End Year</th>
                                </tr>
                            </thead>
                            <tbody>
                                {props.data.goals.length > 0 && (
                                    props.data.goals.map((item, idx) => {

                                        return <tr style={financialDataItemTRStyle}>
                                            <td style={financialDataItemTDStyle}>{item.frequency}</td>
                                            <td style={financialDataItemTDStyle}>{currencyFormatNoDecimals(item.amount)}</td>
                                            <td style={financialDataItemTDStyle}>{item.startYear}</td>
                                            <td style={financialDataItemTDStyle}>{item.endYear}</td>
                                        </tr>

                                    }))}
                            </tbody>
                        </table>
                    </div>
                </div>

            </body>
        </html >
    )
}

export default PdfPlanInput;
